export const CONFIG_LOADED = "CONFIG_LOADED";

export const configReducer = (state = {}, action) => {
  switch (action.type) {
    case CONFIG_LOADED:
      return action.payload;
    default:
      return state;
  }
};
